import { styleConstants } from '@paywithextend/components'
import React from 'react'
import { css } from 'styled-components'

interface SoftAlertBoxProps {
  className?: string
  testId?: string
  onDismiss?: (hasUsers: boolean) => void
}

// TODO: move this into shared repo
const SoftAlertBox: React.FC<React.PropsWithChildren<SoftAlertBoxProps>> = (
  props,
) => {
  return (
    <div
      css={css`
        border-radius: 10px;
        border: 1px solid ${styleConstants.colors.yellow_dark};
        background-color: ${styleConstants.colors.yellow_pale};
        padding: 40px;
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 10px;
      `}
      className={props.className}
      data-testid={props.testId}
    >
      {props.children}
    </div>
  )
}

export default SoftAlertBox
